import store from '../../redux/store';
import updateConsent from './update_consent';
import { boundSetUserPurposes } from '../../redux/actions/consent';

const setPurposesPositive = function () {
    const { vendorList } = store.getState();
    boundSetUserPurposes(vendorList.list.purposes.map(e => e.id));
    updateConsent();
};

export default setPurposesPositive;